import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import Home from "../../../components/Common/Home";
import { GlobalConsumer } from "../../../context/GlobalContext";
import EmailVerification from "../../../components/Common/EmailVerification";
import Api from "../../../lib/componentApi";
import getAppErrors from "../../../lib/appErrors";
import customUrlSearchParams from "../../../lib/customUrlSearchParams";
import AppErrors from "../../../components/Common/AppErrors";
import Unsubscribe from "../../../components/Locale/Unsubscribe";

class MainPage extends Component {
  constructor(props) {
    super(props);
    const searchParams = new customUrlSearchParams(props.location.search);
    const token = searchParams.get("token");

    let emailVerificationCode, walletEmailVerificationCode, unsubscribeToken;
    if (props.name === "email-verification") {
      emailVerificationCode = props.match.params.key;
    } else if (props.name === "wallet-email-verification") {
      walletEmailVerificationCode = props.match.params.key;
    } else if (props.name === "unsubscribe") {
      unsubscribeToken = token;
    } else if (props.name === "unsubscribe-old") {
      unsubscribeToken = props.match.params.token;
    }

    this.state = {
      emailVerificationCode,
      walletEmailVerificationCode,
      unsubscribeToken,
      unsubscribePopup: false,
      emailVerificationPopup: false,
      errorMessage: null,
      email: null
    };
  }

  componentDidMount() {
    const { emailVerificationCode, walletEmailVerificationCode, unsubscribeToken } = this.state;
    var body = document.body;

    if (emailVerificationCode) {
      Api.post(
          "/api/set/email/verification",
          {key: emailVerificationCode},
          (response, errors) => {
            if (errors) {
              console.log(response, errors);
              if (errors === 503) {
                this.setState(() => {
                  throw errors;
                });
              } else {
                console.log(errors);
              }
            } else if (response.code) {
              body.classList.add("body-overflow");
              const errorMessage = getAppErrors(response.code);
              this.setState({
                errorMessage:
                    (errorMessage && errorMessage.message) || response.message
              });
            } else {
              if (response.status) {
                body.classList.add("body-overflow");
                this.setState({
                  emailVerificationPopup: true,
                  email: response.params[0]
                });
              }
            }
          }
      );
    } else if (walletEmailVerificationCode) {
      Api.post(
          "/api/set/email/verification",
          {key: walletEmailVerificationCode},
          (response, errors) => {
            if (errors) {
              console.log(response, errors);
              if (errors === 503) {
                this.setState(() => {
                  throw errors;
                });
              } else {
                console.log(errors);
              }
            } else if (response.code) {
              if (response.code === 2091) {
                window.location.href = 'https://www.burdiapp.com/email-already-verified';
              } else {
                window.location.href = 'https://www.burdiapp.com/email-verification-error';
              }
              return null;
            } else {
              if (response.status) {
                window.location.href = 'https://www.burdiapp.com/email-verification-successful';
                return null;
              }
            }
          }
      );
    } else if (unsubscribeToken) {
      Api.post(
        "/api/check/unsubscribeToken",
        { token: unsubscribeToken },
        (response, errors) => {
          if (errors) {
            if (errors === 503) {
              this.setState(() => {
                throw errors;
              });
            } else {
              console.log(errors);
            }
          } else if (response.code) {
            body.classList.add("body-overflow");
            const errorMessage = getAppErrors(response.code) || {
              message: "Unsubscribe token error."
            };
            this.setState({
              errorMessage:
                (errorMessage && errorMessage.message) || response.message
            });
          } else {
            body.classList.add("body-overflow");
            this.setState({
              unsubscribePopup: true,
              email: response.email
            });
          }
        }
      );
    }
  }
  onClosePopup = () => {
    window.location.replace("/");
  };
  unsubscribeClosePopup = () => {
    window.location.href = 'https://www.burdiapp.com/personal';
  };
  render() {
    const { authed } = this.props;
    const {
      emailVerificationPopup,
      errorMessage,
      email,
      unsubscribePopup,
      unsubscribeToken
    } = this.state;
    return (
      <GlobalConsumer>
        {({ user }) => (
          <>
            {(unsubscribePopup && (
              <Unsubscribe
                token={unsubscribeToken}
                onClosePopup={this.unsubscribeClosePopup}
                email={email}
              />
            )) || <noscript />}
            {emailVerificationPopup && (
              <EmailVerification
                onClosePopup={this.onClosePopup}
                email={email}
              />
            )}
            {errorMessage && (
              <AppErrors
                message={errorMessage}
                onClickClose={this.onClosePopup}
              />
            )}
            <Home user={user} authed={authed} />
          </>
        )}
      </GlobalConsumer>
    );
  }
}

export default withRouter(MainPage);
